module.exports = __webpack_public_path__ + "static/media/room-10.5c642bce.jpg";